import createQueryRequest from 'services/createQueryRequest';
import { useQuery } from '@tanstack/react-query';
import useAPI from 'services/useAPI';

export const createProviderQuery = (api, providerId, options) => ({
  queryKey: ['provider', providerId],
  queryFn: createQueryRequest(api.core.getProvider),
  enabled: providerId != null,
  retry: 0,
  initialData: {},
  ...options
});

const useProviderQuery = (providerId, options) => {
  const api = useAPI();
  return useQuery(createProviderQuery(api, providerId, options));
};

export default useProviderQuery;
